import React from "react";
import FooterSection from "../../components/sections/FooterSection";

function PrivacyPolicyPage(props) {
    return (
        <>

            <div className="uk-container uk-margin-large-top">
                <h1>Privacy Policy</h1>

                <p><strong>Effective Date:</strong> 27th of August, 2025</p>

                <section>
                    <h2>1. General Statement</h2>
                    <p>
                        Jai International LLP (“Company”) respects the privacy of its Users.
                        As of August 2025, the Company does not sell or share personal data with third parties for any purposes.
                    </p>
                </section>

                <section>
                    <h2>2. Data Collected</h2>
                    <ol>
                        <li>
                            <strong>Account Information:</strong> email address and hashed password.
                        </li>
                        <li>
                            <strong>Service Data:</strong> passport copies and documents voluntarily submitted for visa services.
                        </li>
                        <li>
                            <strong>User Content:</strong> reviews and avatars voluntarily provided by Users.
                        </li>
                        <li>
                            <strong>Analytics:</strong> anonymous website usage statistics through Google Analytics and Yandex Metrica.
                        </li>
                        <li>
                            <strong>Language Preference:</strong> stored locally in the User’s browser.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>3. Data Storage and Security</h2>
                    <ol>
                        <li>Data is stored in encrypted form in MongoDB Atlas (Ireland) and in Almaty, Kazakhstan.</li>
                        <li>Passwords are stored only in hashed form and never in plain text.</li>
                        <li>JWT tokens are used for identification; cookies are not used.</li>
                    </ol>
                </section>

                <section>
                    <h2>4. Data Use</h2>
                    <ol>
                        <li>Data is used exclusively to provide consulting, tours, and visa processing services.</li>
                        <li>Anonymous analytics data is used to improve the website and service performance.</li>
                    </ol>
                </section>

                <section>
                    <h2>5. Data Retention</h2>
                    <ol>
                        <li>
                            Personal data is deleted within 24 hours after account deletion is requested, except as required by law.
                        </li>
                        <li>
                            Financial records are retained for at least six weeks for compliance and may be provided to the User upon request.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>6. User Rights</h2>
                    <ol>
                        <li>Right to access, correct, or delete personal data.</li>
                        <li>Right to request removal of reviews or avatars.</li>
                        <li>Right to object to processing of data for analytics purposes (by disabling third-party metrics in browser settings).</li>
                    </ol>
                </section>

                <section>
                    <h2>7. Data Sharing</h2>
                    <ol>
                        <li>Personal data is not sold or shared with third parties for advertising.</li>
                        <li>Passport and visa documents are shared only with relevant government authorities as required for processing.</li>
                    </ol>
                </section>

                <section>
                    <h2>8. Governing Law</h2>
                    <p>
                        This Privacy Policy is governed by the laws of the Republic of Kazakhstan.
                    </p>
                </section>

                <section>
                    <h2>9. Contact</h2>
                    <p>
                        For privacy-related inquiries, contact the Company at:
                    </p>
                    <ul>
                        <li>WhatsApp (calls and messages): +77750912804 (Buba Jallow)</li>
                        <li>Registered office: Korgalzhyn Highway 19T, "Korgalzhyn Business Center" Astana, Republic of Kazakhstan</li>
                    </ul>
                </section>
            </div>
            <FooterSection />
        </>
    );
}

export default PrivacyPolicyPage;
